import { Body } from '@lendi-ui/typography';

import { FIELD_PATHS } from '@funnels/constants';
import { BrokerInterviewsGuarantorEntityIndex } from '@funnels/types';

import { FunnelGrid, FunnelGridUnit } from '../../../Common';
import { CheckboxField } from '../../../Fields';

export const BrokerDeclaration = ({ brokerInterviewsGuarantorIndex }: BrokerInterviewsGuarantorEntityIndex) => {
  return (
    <FunnelGrid mt="md" mb="lg">
      <FunnelGridUnit size={1 / 2}>
        Confirm that the following is correct:
        <ul>
          <li>
            <Body mb="sm">
              The Guarantor acknowledges they are not under any pressure, nor the Borrower's influence, to give this
              guarantee AND you have no reason to suspect otherwise (e.g. are you afraid someone will do something, or
              refuse to do something, if you do not sign this Guarantee).
            </Body>
          </li>
          <li>
            <Body mb="sm">
              The guarantor appears to clearly understand English, and there is no reason to believe they have
              difficulty understanding their obligations as guarantor (e.g. under the influence of alcohol, impaired
              mental capacity, difficulties with English or literacy, or any language barriers).
            </Body>
          </li>
          <li>
            <Body mb="sm">
              The Guarantor understands what a Guarantee is and that they understand their obligations as a Guarantor.
            </Body>
          </li>
          <li>
            <Body mb="sm">
              There's no reason to suspect the Guarantor is subject to any unreasonable or unfair conduct by anyone
              involved in this transaction (e.g. Financial Abuse).
            </Body>
          </li>
          <li>
            <Body mb="sm">
              There's no reason to suspect the Guarantor is subject to any misrepresentation as to why the Guarantee is
              needed.
            </Body>
          </li>
        </ul>
      </FunnelGridUnit>
      <FunnelGridUnit size={1 / 2}>
        <CheckboxField
          name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_HAS_BROKER_DECLARATION(brokerInterviewsGuarantorIndex)}
          checkboxLabel="I acknowledge and confirm the information is correct"
          size="sm"
          isOptional
        />
      </FunnelGridUnit>
    </FunnelGrid>
  );
};
